import { View } from "@react-pdf/renderer";
import { CellTextBoxDot, styles } from "../reportingHelpers";
import React from "react";

export const SideTableRow = (props) => {
  const { labelText, teamText, rowStyle } = props;
  return (
    <View
      style={{
        ...styles.tableRowFrench,
        ...rowStyle,
        height: "5mm",
        borderColor: "white",
      }}
    >
      <CellTextBoxDot
        style={{
          width: "40mm",
          height: "5mm",
          textAlign: "left",
          paddingLeft: 2,
          borderColor: "white",
        }}
      >
        {labelText}
      </CellTextBoxDot>
      <CellTextBoxDot style={{ height: "5mm", borderColor: "white" }}>
        {teamText}
      </CellTextBoxDot>
    </View>
  );
};
